const themeContract = {
  argos: {
    filterLabel: {
      backgroundColor: 'brand1',
      color: 'white'
    }
  },
  habitat: {
    filterLabel: {
      backgroundColor: 'brand1',
      color: 'white'
    }
  },
  tu: {
    filterLabel: {
      backgroundColor: 'brand1',
      color: 'white'
    }
  }
}

export { themeContract }
